var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-hostess-center", class: [_vm.packageName] },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `paddingTop:${_vm.barHeight}px;`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: "", "left-arrow": "" },
            on: { "click-left": _vm.closeWeb, "click-right": _vm.handleToRule },
            scopedSlots: _vm._u(
              [
                {
                  key: "left",
                  fn: function () {
                    return [
                      _c("img", {
                        staticClass: "left-nav",
                        attrs: {
                          src: require("@/assets/packageAssets/common/arrow05.png"),
                          alt: "",
                        },
                      }),
                      _c("span", { staticClass: "tit-left" }, [
                        _vm._v(_vm._s(_vm.$t("lang.host.hostessCenter"))),
                      ]),
                    ]
                  },
                  proxy: true,
                },
                _vm.chooseTab == 2
                  ? {
                      key: "right",
                      fn: function () {
                        return [
                          _c("span", { staticClass: "tit-right" }, [
                            _c("img", {
                              staticClass: "left-nav",
                              attrs: {
                                src: require("@/assets/packageAssets/common/rules01.png"),
                                alt: "",
                              },
                            }),
                          ]),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _c("div", { staticClass: "switch-tab" }, [
        _c(
          "div",
          {
            staticClass: "tab",
            class: { activeTab: _vm.chooseTab == 1 },
            on: {
              click: function ($event) {
                return _vm.changeTab(1)
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("lang.host.myLevel")))]
        ),
        _c(
          "div",
          {
            staticClass: "tab",
            class: { activeTab: _vm.chooseTab == 2 },
            on: {
              click: function ($event) {
                return _vm.changeTab(2)
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("lang.host.myViolation")))]
        ),
      ]),
      _vm.chooseTab == 1
        ? _c(
            "div",
            [
              _c("MyLevel", {
                ref: "childLevel",
                on: {
                  hostessData: _vm.hostessData,
                  hostessIncome: _vm.hostessIncome,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.chooseTab == 2 ? _c("div", [_c("MyViolation")], 1) : _vm._e(),
      _vm.sevenTimeFlag
        ? _c(
            "van-popup",
            {
              staticClass: "van-popup-box",
              attrs: { "lock-scroll": false },
              on: {
                close: function ($event) {
                  _vm.showMyLevelDia == false
                },
              },
              model: {
                value: _vm.showMyLevelDia,
                callback: function ($$v) {
                  _vm.showMyLevelDia = $$v
                },
                expression: "showMyLevelDia",
              },
            },
            [
              _c("div", { staticClass: "level-dia" }, [
                _c("div", { staticClass: "level-dia-light" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/packageAssets/views/P1_Girls/HostessCenter/vava/bulibuli.png"),
                      alt: "",
                    },
                  }),
                ]),
                _c("span", { staticClass: "tit" }, [
                  _vm._v(_vm._s(_vm.$t("lang.host.myLevel"))),
                ]),
                _c("div", { staticClass: "level-img" }, [
                  _c("div", {
                    staticClass: "bg-img-box",
                    style: {
                      "background-image": `url(${_vm.badgeStyle(
                        _vm.curLevel
                      )})`,
                    },
                  }),
                  _c("span", { staticClass: "level-num" }, [
                    _vm._v(_vm._s(_vm.curLevel)),
                  ]),
                ]),
                _c("span", { staticClass: "desc desc1" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$t("lang.host.currentLevelIs")) + " "
                  ),
                  _c("i", { staticStyle: { color: "#ffd64c" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("lang.Lv")) + "." + _vm._s(_vm.curLevel)
                    ),
                  ]),
                ]),
                _c("span", { staticClass: "desc" }, [
                  _vm._v(_vm._s(_vm.$t("lang.host.youCanSetCallIncome"))),
                ]),
                _c("div", { staticClass: "income" }, [
                  _vm._v(" " + _vm._s(_vm.myIncome) + " "),
                  _c("img", {
                    attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                  }),
                  _vm._v(" /" + _vm._s(_vm.$t("lang.host.min")) + " "),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "level-dia-btn",
                  on: { click: _vm.setMyincome },
                },
                [_vm._v(_vm._s(_vm.$t("lang.host.set")))]
              ),
            ]
          )
        : _vm._e(),
      _c(
        "van-popup",
        {
          staticClass: "van-popup-box",
          attrs: { "lock-scroll": false },
          on: {
            close: function ($event) {
              _vm.showNewbieDia == false
            },
          },
          model: {
            value: _vm.showNewbieDia,
            callback: function ($$v) {
              _vm.showNewbieDia = $$v
            },
            expression: "showNewbieDia",
          },
        },
        [
          _c("div", { staticClass: "level-dia" }, [
            _c("div", { staticClass: "level-dia-light" }, [
              _c("img", {
                attrs: {
                  src: require("@/assets/packageAssets/views/P1_Girls/HostessCenter/vava/bulibuli.png"),
                  alt: "",
                },
              }),
            ]),
            _c("span", { staticClass: "tit" }, [
              _vm._v(_vm._s(_vm.$t("lang.host.newbiePrivilege"))),
            ]),
            _c("div", { staticClass: "level-img" }, [
              _c("div", {
                staticClass: "bg-img-box",
                style: {
                  "background-image": `url(${_vm.badgeStyle(_vm.curLevel)})`,
                },
              }),
              _c("span", { staticClass: "level-num" }, [
                _vm._v(_vm._s(_vm.curLevel)),
              ]),
            ]),
            _c("span", { staticClass: "desc desc1 note-level" }, [
              _vm._v(" " + _vm._s(_vm.$t("lang.host.youUpgradeTo")) + " "),
              _c("i", { staticStyle: { color: "#ffd64c" } }, [
                _vm._v(_vm._s(_vm.$t("lang.Lv")) + "." + _vm._s(_vm.curLevel)),
              ]),
            ]),
            _c("span", { staticClass: "desc" }, [
              _vm._v(
                _vm._s(
                  _vm.handleTowText(
                    _vm.$t("lang.host.enjoyPrivilegeForDays"),
                    "%s",
                    _vm.curLevel,
                    7
                  )
                )
              ),
            ]),
            _c("div", { staticClass: "note" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("lang.host.note")) + ":")]),
              _c("div", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.handleOneText(
                        _vm.$t("lang.host.newbiePrivilegeNotes"),
                        "%s",
                        7
                      )
                    ) +
                    " "
                ),
              ]),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "level-dia-btn",
              on: {
                click: function ($event) {
                  _vm.showNewbieDia = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("lang.ok")))]
          ),
        ]
      ),
      _c(
        "van-popup",
        {
          staticClass: "van-popup-box",
          attrs: { "lock-scroll": false },
          on: {
            close: function ($event) {
              _vm.showLevelUpDia == false
            },
          },
          model: {
            value: _vm.showLevelUpDia,
            callback: function ($$v) {
              _vm.showLevelUpDia = $$v
            },
            expression: "showLevelUpDia",
          },
        },
        [
          _c("div", { staticClass: "level-dia" }, [
            _c("div", { staticClass: "level-dia-light" }, [
              _c("img", {
                attrs: {
                  src: require("@/assets/packageAssets/views/P1_Girls/HostessCenter/vava/bulibuli.png"),
                  alt: "",
                },
              }),
            ]),
            _c("span", { staticClass: "tit" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k156"))),
            ]),
            _c("div", { staticClass: "level-img" }, [
              _c("div", {
                staticClass: "bg-img-box",
                style: {
                  "background-image": `url(${_vm.badgeStyle(_vm.curLevel)})`,
                },
              }),
              _c("span", { staticClass: "level-num" }, [
                _vm._v(_vm._s(_vm.curLevel)),
              ]),
            ]),
            _c("span", { staticClass: "desc desc1" }, [
              _vm._v(
                " " + _vm._s(_vm.$t("lang.host.congratulationsUpgradeTo")) + " "
              ),
              _c("i", { staticStyle: { color: "#ffd64c" } }, [
                _vm._v(_vm._s(_vm.$t("lang.Lv")) + "." + _vm._s(_vm.curLevel)),
              ]),
            ]),
            _c("span", { staticClass: "desc" }, [
              _vm._v(_vm._s(_vm.$t("lang.host.privateCallIncomeIncreases"))),
            ]),
            _c("div", { staticClass: "income" }, [
              _vm._v(" " + _vm._s(_vm.myIncome) + " "),
              _c("img", { attrs: { src: _vm.getMatchImg("beans"), alt: "" } }),
              _vm._v(" /" + _vm._s(_vm.$t("lang.host.min")) + " "),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "level-dia-btn",
              on: {
                click: function ($event) {
                  _vm.showLevelUpDia = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("lang.host.goCheck")))]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }